angular.module('impactx.user').controller('UserAvatarAutocompleteCtrl', [
    'AutocompleteSelectionPanel',
    'TranslationService',
    UserAvatarAutocompleteController
]);

function UserAvatarAutocompleteController(AutocompleteSelectionPanel, TranslationService) {
    var self = this;
    self.trns = {
        add: TranslationService.get('add')
    };

    self.$onInit = function () {
        if (!self.selected) {
            self.selected = [];
        }
    };

    self.removeEntry = function (entry) {
        if (entry) {
            var index = self.selected.indexOf(entry);
            if (index >= 0) {
                self.selected.splice(index, 1);
                if (self.dialogData) {
                    self.dialogData.$setDirty();
                }
            }
            self.doOnChange();
        }
    };

    self.openSelection = function (event) {
        if (event) {
            event.stopPropagation();
        }

        var config = {
            title: self.title,
            uri: self.uri,
            event: event,
            selected: self.selected
        };
        AutocompleteSelectionPanel.openPanel(config).then(function (selection) {
            if (selection) {
                self.selected.push(selection);
                if (self.dialogData) {
                    self.dialogData.$setDirty();
                }
                self.doOnChange();
            }
        });
    };

    self.doOnChange = function () {
        if(self.onChangeFunc) {
            self.onChangeFunc();
        }
    }
}